import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular/src/interfaces';

@Component({
  selector: 'app-view-attachment-file-no-click',
  template: '<i class="{{getIcon()}}"></i>',
  styleUrls: ['./view-attachment-file-no-click.component.scss']
})
export class ViewAttachmentFileNoClickComponent implements ICellRendererAngularComp {

  private params: any;

  agInit(params: any): void {
    this.params = params;
  }


  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  /**
   * @name getIcon
   * @description Return icon
   */
  getIcon() {
    return this.params.value ? 'fa fa-file' : 'm-btn-warning';
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/view-attachment-file-no-click/view-attachment-file-no-click.component.ts